const asyncSessionStorage = {
  setItem: async (key, value) => {
    await null;
    return window.sessionStorage.setItem(key, value);
  },
  getItem: async (key) => {
    await null;
    return window.sessionStorage.getItem(key);
  },
  removeItem: async (key) => {
    await null;
    return window.sessionStorage.removeItem(key);
  },
  clear: async () => {
    await null;
    return window.sessionStorage.clear();
  },
  getItemSync: (key) => window.sessionStorage.getItem(key),
};

export default asyncSessionStorage;
